import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

// components
import MemberTagsList from "components/MemberTagsList";
import Page from "components/Page";
import FormMemberTag from "components/FormMemberTag";

// styles
import styles from "./styles";

class WrapperMemberTagsPage extends Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    loading: PropTypes.bool,

    //memberTags
    memberTags: PropTypes.array,
    getMemberTagById: PropTypes.func,
    createMemberTag: PropTypes.func,
    deleteMemberTag: PropTypes.func,
    updateMemberTag: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedMemberTag: undefined,
      formMemberTagOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { memberTags } = this.props;

    switch (index) {
      case 0:
        return (
          <MemberTagsList
            memberTags={memberTags}
            onSelect={(selectedMemberTag) =>
              this.setState({
                selectedMemberTag,
                formMemberTagOpen: true,
              })
            }
          />
        );
      default:
    }
  }

  render() {
    const {
      classes,
      history,
      loading,
      createMemberTag,
      deleteMemberTag,
      updateMemberTag,
      refresh,
    } = this.props;

    const { index, selectedMemberTag, formMemberTagOpen } = this.state;

    return (
      <Page
        helmet={"MemberTags"}
        loadingMessage={"Loading Document"}
        loading={loading}
        fab={
          <Fab
            variant="fab"
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={() => this.setState({ formMemberTagOpen: true })}
          >
            <AddIcon />
          </Fab>
        }
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push(`?index=${v}`);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="MemberTags"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormMemberTag
          open={formMemberTagOpen}
          memberTag={selectedMemberTag}
          close={() => {
            this.setState({
              formMemberTagOpen: false,
            });
            setTimeout(
              () =>
                this.setState({
                  selectedMemberTag: undefined,
                }),
              200
            );
          }}
          createMemberTag={createMemberTag}
          deleteMemberTag={deleteMemberTag}
          updateMemberTag={updateMemberTag}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperMemberTagsPage);
